import { s3AdapterApi } from "./http-clients";

type S3UrlResponse = string | { content?: string };

function parseS3UrlResponse(data: S3UrlResponse): string | null {
  if (typeof data === "string" && data) {
    return data;
  }

  if (data && typeof data === "object" && "content" in data) {
    const { content } = data;
    if (typeof content === "string" && content) {
      return content;
    }
  }

  return null;
}

/** GET /s3-adapter/api/v1/files/{fileId}?type=URL — presigned ссылка (~1 мин) */
export async function fetchS3FileUrl(fileId: string): Promise<string> {
  const response = await s3AdapterApi.get<S3UrlResponse>(
    `files/${fileId}?type=URL`,
  );
  const fileUrl = parseS3UrlResponse(response.data);

  if (!fileUrl) {
    throw new Error("Ссылка на документ не найдена");
  }

  return fileUrl;
}
